import {
    array,
    boolean,
    nativeEnum,
    object,
    record,
    string,
    TypeOf,
} from 'zod';

import { ISO6391 } from '../../ISO-639-1';

/* ---------------------------- MediaStreamFormat --------------------------- */

export enum MediaStreamFormat {
    DASH = 'dash',
    HLS = 'hls',
    MP4 = 'mp4',
    SmoothStream = 'smoothstream',
}

/* ----------------------------- MediaStreamDrm ----------------------------- */

export const MediaStreamDrm = object({
    type: string(),
    encryption: string(),
    key: string(),
    checksum: string(),
    licenseUrl: string(),
    // Not actually part of the Easel API yet but needed for Brightcove
    headers: record(string()).optional(),
    certificateUrl: string().optional(),
    isBrightcove: boolean().default(false),
});
export type MediaStreamDrm = TypeOf<typeof MediaStreamDrm>;

/* ------------------------------- MediaStream ------------------------------ */

export const MediaStream = object({
    drm: MediaStreamDrm.optional(),
    format: nativeEnum(MediaStreamFormat),
    url: string(),
});

export type MediaStream = TypeOf<typeof MediaStream>;

/* --------------------------- ProductMediaFeature -------------------------- */

export const ProductMediaTrailer = object({
    audioTracks: record(nativeEnum(ISO6391), string()).optional(),
    streams: array(MediaStream),
    subtitles: record(nativeEnum(ISO6391), string()).optional(),
    links: object({
        videoAds: string().optional(),
        thumbnails: string().optional(),
    }).optional(),
});

export type ProductMediaTrailer = TypeOf<typeof ProductMediaTrailer>;
